// ============================================================================
// APPROVAL SERVICE
// ============================================================================

import { get, post } from '../client/axiosClient';
import { approvalEndpoints } from '../endpoints/approval.endpoints';
import { buildEndpointWithQuery } from '../endpoints/base.endpoints';
import type {
  ApiResponse,
  PaginatedResponse,
} from '../types';
import { transformPaginatedResponse } from '../types/common.types';
import type {
  ApprovalDashboardItem,
  ApprovalDetailItem,
  ApprovalActionPayload,
  ApprovalHistory,
  ApprovalDashboardFilterParams,
  ApprovalAuditReportEntry,
} from '../types/approval.types';

class ApprovalService {
  async getDashboard(params?: ApprovalDashboardFilterParams): Promise<PaginatedResponse<ApprovalDashboardItem>> {
    const endpoint = params
      ? buildEndpointWithQuery(approvalEndpoints.dashboard(), params)
      : approvalEndpoints.dashboard();
    const response = await get(endpoint);
    return transformPaginatedResponse<ApprovalDashboardItem>(response.data);
  }

  async getDetail(recordType: string, recordId: string): Promise<ApiResponse<ApprovalDetailItem>> {
    const response = await get<ApiResponse<ApprovalDetailItem>>(approvalEndpoints.detail(recordType, recordId));
    return response.data;
  }

  async processAction(payload: ApprovalActionPayload): Promise<ApiResponse<void>> {
    const response = await post<ApiResponse<void>>(approvalEndpoints.action(), payload);
    return response.data;
  }

  async getHistory(recordType: string, recordId: string): Promise<ApiResponse<ApprovalHistory[]>> {
    const response = await get<ApiResponse<ApprovalHistory[]>>(approvalEndpoints.history(recordType, recordId));
    return response.data;
  }

  async getAuditReport(): Promise<ApiResponse<ApprovalAuditReportEntry[]>> {
    const response = await get<ApiResponse<ApprovalAuditReportEntry[]>>(approvalEndpoints.auditReport());
    return response.data;
  }
}

export const approvalService = new ApprovalService();
export default approvalService;
